import React from 'react';
import { useParams } from 'react-router-dom';
import { isLocalePrefix } from 'utils/localePath';
import IntranetLogin from 'pages/backoffice/login';
import NotFound from 'pages/notfound';

const LocaleIntranetLogin = () => {
  const { locale } = useParams();

  if (!isLocalePrefix(locale)) {
    return <NotFound />;
  }

  return <IntranetLogin />;
};

export default LocaleIntranetLogin;
